/**
 * Advertiser Analytics Integration form.
 *
 * Views: advertisers/partials/form-integrations
 


if ($('#app-advertisers-integrations-form').length) {
    show_loader();
    var advertiser_analytics_data = [];
    var advertiser_analytics_data_current = [];
    var selects = {
        'account': $('#advertiser_analytics_account'),
        'profile': $('#advertiser_analytics_profile'),
        'property': $('#advertiser_analytics_property'),
        'view': $('#advertiser_analytics_view'),
    };
    var advertiser_analytics_button = $('#advertiser_analytics_submit');

    form_validator('#app-advertisers-integrations-form',
        {},
        {}
    );
    $.ajax({
        type: 'GET',
        url: '/analytics/views',
        dataType: 'json',
        encode: true,
        success: function (data) {
            advertiser_analytics_data = data;
            advertiser_analytics_data_current = advertiser_analytics_data;

            selects['account'].html('');
            selects['account'].append('<option value=""></option>');
            $.each(data, function (index, value) {
                selects['account'].append('<option value="' + index + '">' + value['auth_email'] + '</option>');
            });

            if (selects['account'].data('select2')) {
                selects['account'].data('select2').destroy();
            }
            selects['account'].select2({
                placeholder: "Choose one to continue..."
            });

            if ($('#analytics_fill').length) {
                advertiser_analytics_fill();
            }

            selects['account'].on('select2:select', function () {
                advertiser_analytics_account_change(this);
            });

            hide_loader();
        },
        error: function (xhr) {
            ajax_error();
            hide_loader();
        }
    });
}

var advertiser_analytics_account_change = function (select) {
    selects['property'].html('').attr('disabled', 'disabled');
    selects['view'].html('').attr('disabled', 'disabled');
    advertiser_analytics_button.attr('disabled', 'disabled');

    advertiser_analytics_data_current = advertiser_analytics_data[$(select).val()]['profiles'];

    selects['profile'].html('');
    selects['profile'].append('<option value=""></option>');

    $.each(advertiser_analytics_data_current, function (index, value) {
        selects['profile'].append('<option value="' + index + '">' + index + '</option>');
    });

    if (selects['profile'].data('select2')) {
        selects['profile'].data('select2').destroy();
    }
    selects['profile'].select2({
        placeholder: "Choose one to continue..."
    });
    selects['profile'].attr('disabled', null);

    selects['profile'].on('select2:select', function () {
        advertiser_analytics_profile_change(this);
    });
};

var advertiser_analytics_profile_change = function (select) {
    selects['view'].html('').attr('disabled', true);
    advertiser_analytics_button.attr('disabled', 'disabled');

    advertiser_analytics_data_current = advertiser_analytics_data[$(selects['account']).val()]['profiles'][$(select).val()];
    selects['property'].html('');
    selects['property'].append('<option value=""></option>');

    $.each(advertiser_analytics_data_current, function (index, value) {
        selects['property'].append('<option value="' + index + '">' + value['property'] + '</option>');
    });

    if (selects['property'].data('select2')) {
        selects['property'].data('select2').destroy();
    }
    selects['property'].select2({
        placeholder: "Choose one to continue..."
    });
    selects['property'].attr('disabled', null);

    selects['property'].on('select2:select', function () {
        advertiser_analytics_property_change(this);
    });
};

var advertiser_analytics_property_change = function (select) {
    advertiser_analytics_button.attr('disabled', 'disabled');

    advertiser_analytics_data_current = advertiser_analytics_data[$(selects['account']).val()]['profiles'][$(selects['profile']).val()][$(select).val()];
    selects['view'].html('');
    selects['view'].append('<option value=""></option>');

    $.each(advertiser_analytics_data_current['views'], function (index, value) {
        selects['view'].append('<option value="' + value['id'] + '">' + value['name'] + '</option>');
    });

    if (selects['view'].data('select2')) {
        selects['view'].data('select2').destroy();
    }
    selects['view'].select2({
        placeholder: "Choose one to continue..."
    });
    selects['view'].attr('disabled', null);

    selects['view'].on('select2:select', function () {
        advertiser_analytics_view_change(this);
    });
};

var advertiser_analytics_view_change = function (select) {
    advertiser_analytics_button.attr('disabled', null);
};

var advertiser_analytics_fill = function () {
    selects['account'].val($('#analytics_fill_account').val());
    advertiser_analytics_account_change(selects['account']);
    selects['account'].trigger('change.select2');
    selects['profile'].val($('#analytics_fill_profile').val());
    advertiser_analytics_profile_change(selects['profile']);
    selects['profile'].trigger('change.select2');
    selects['property'].val($('#analytics_fill_property').val());
    advertiser_analytics_property_change(selects['property']);
    selects['property'].trigger('change.select2');
    selects['view'].val($('#analytics_fill_view').val());
    advertiser_analytics_view_change(selects['view']);
    selects['view'].trigger('change.select2');
};*/